<mat-toolbar class="tcb-footer">
  <footer>
    <div>
      <div class="footer_text" [innerHTML]="footerText"></div>
    </div>
  </footer>
</mat-toolbar>
